import { CheckboxCheckedState } from '@ark-ui/react'
import { Checkbox as ChakraCheckbox, CheckboxLabelProps, CheckboxRootProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends Omit<CheckboxRootProps, 'onChange' | 'onCheckedChange'> {
  labelProps?: Omit<CheckboxLabelProps, 'children'>
  onChange?: (checked: CheckboxCheckedState) => void
}

export default forwardRef<HTMLLabelElement, Props>(
  ({ children, labelProps, onChange, ...rest }, ref) => {
    return (
      <ChakraCheckbox.Root
        colorPalette="black"
        cursor="pointer"
        onCheckedChange={p => onChange?.(p.checked)}
        onClick={e => e.stopPropagation()}
        ref={ref}
        {...rest}
      >
        <ChakraCheckbox.HiddenInput />
        <ChakraCheckbox.Control cursor="pointer" />
        {children && <ChakraCheckbox.Label {...labelProps}>{children}</ChakraCheckbox.Label>}
      </ChakraCheckbox.Root>
    )
  }
)
